
    import Vue from 'vue';

    export default Vue.extend({
        name: "BillingCycleSelection", 
        props: {
            billingCycles: {
                type: Array,
                default: () => [], 
            },
            selectedBillingCycle: {
                type: Object,
            }
        },
        methods: {
            selectBillingCycle(cycle) {
                this.$emit('handleSelect', cycle);
            }
        }
    })
